<template>
  <v-card class="ui-module-card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Trámites administrativos</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row v-if="faltas.length > 0">
          <v-col cols="4" v-for="falta in faltas" :key="falta.id">
            <v-card color="primary" class="ui-module-card">
              <v-card-title class="justify-center d-block" align="center">
                <div class="text-h6 font-weight-bold">{{ falta.CatTipoFalta.title }}</div>
                <div class="text-subtitle-2">Registrada el {{ falta.fecha }}</div>
              </v-card-title>
              <v-card-text align="center">
                <v-container>
                  <v-row>
                    <v-col cols="12" align="center" v-if="falta.PersonalEmisor">
                      <div class="text-subtitle-2">Falta levantada por</div>
                      <div class="text-subtitle-2 font-weight-bold">
                        {{ getFullName(falta.PersonalEmisor) }}
                      </div>
                      <div class="text-subtitle-2 font-weight-bold">
                        {{ falta.PersonalEmisor.CUIP }}
                      </div>
                    </v-col>
                    <template v-if="falta.fk_idTipoFalta == 1">
                      <v-col cols="6" align="left">
                        <div class="text-subtitle-2">Fecha de sanción</div>
                      </v-col>
                      <v-col cols="6" align="right">
                        <div class="text-subtitle-2 font-weight-bold">
                          {{ falta.fechaDesde }}
                        </div>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="6" align="left">
                        <div class="text-subtitle-2">Desde</div>
                      </v-col>
                      <v-col cols="6" align="right">
                        <div class="text-subtitle-2 font-weight-bold">
                          {{ falta.fechaDesde }}
                        </div>
                      </v-col>
                      <v-col cols="6" align="left">
                        <div class="text-subtitle-2">Hasta</div>
                      </v-col>
                      <v-col cols="6" align="right">
                        <div class="text-subtitle-2 font-weight-bold">
                          {{ falta.fechaHasta }}
                        </div>
                      </v-col>
                    </template>
                    <v-col cols="12" align="center">
                      <div class="text-subtitle-2">Motivo</div>
                      <div class="text-subtitle-2 font-weight-bold">
                        {{ falta.motivo }}
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
                <v-img :src="falta.URL" contain v-if="getDocumentType(falta.URL) == 'img'">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <embed
                  v-else-if="getDocumentType(falta.URL) == 'pdf'"
                  width="100%"
                  class="pdf"
                  name="plugin"
                  :src="falta.URL + '#toolbar=0&navpanes=0&scrollbar=0'"
                  type="application/pdf"
                />
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn color="secondary" v-on:click="download(falta.URL)">Descargar</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" align="center">
            <div class="text-h6">Este elemento no cuenta con trámites administrativos</div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    ...mapGetters('faltasAdministrativas', {
      faltas: 'getFaltasAdministrativas',
    }),
  },
  async mounted() {
    if (this.idPersonal) {
      await this.fetchFaltasAdministrativasByPersonal(this.idPersonal)
    }
  },
  methods: {
    ...mapActions('faltasAdministrativas', ['fetchFaltasAdministrativasByPersonal']),
    getFullName(personal) {
      return [personal.nombre, personal.primerApellido, personal.segundoApellido].filter(Boolean).join(' ')
    },
    getDocumentType(url) {
      if (!url) return ''
      if (url.endsWith('.pdf')) return 'pdf'
      if (url.match(/\.(jpeg|jpg|gif|png)$/)) return 'img'
      return ''
    },
    download(url) {
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
/* Cards internas */
::v-deep .ui-module-card {
  background: rgba(26, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-card:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 8px 32px rgba(var(--v-secondary-base-rgb), 0.2) !important;
  transform: translateY(-2px);
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

/* Dividers */
::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

.text-h5,
.text-h6 {
  color: #ffffff !important;
}

::v-deep .text-subtitle-2 {
  color: #e0e0e0 !important;
}
</style>
